module.exports = __webpack_public_path__ + "img/8da08a5.png";